import { UnitTest } from "../UnitTestClass";
import { SCHEMAS } from "../../constants";

export const validateQuotaComponentsSchema = (dataset) => {
  // 1. Check schema
  const bcBuilderValidations = new UnitTest(dataset);
  const checkSchema = bcBuilderValidations.checkSchema(
    SCHEMAS.quotaComponentsSchema
  );
  return { checkSchema };
};

export const validateQuotaComponentsIntra = (dataset) => {
  const bcBuilderValidations = new UnitTest(dataset);
  // 1. Duplicates Test on QuotaComponent
  const duplicatesTest = bcBuilderValidations.checkDuplicates([
    "QuotaComponent",
  ]);

  return { duplicatesTest };
};
